export default {
  name: 'emapupload',
  label: '文件上传',
  icon: 'el-icon-upload',
  config: [{
    // 可修改的配置选项
    xtype: 'number',
    options: {
      label: '文件个数限制',
      name: 'limit',
      default: 3,
      dataType: 'Number'
    }
  }, {
    // 可修改的配置选项
    xtype: 'text',
    options: {
      label: '上传按钮文字',
      name: 'btnText',
      default: '上传文件'
    }
  }],

  validate(value, elemConfig) {
    // TODO: 纳入表单整体的校验方法
    console.log(value, elemConfig);
  }

};